/**
 * Kody rodzaju kontaktu z TMS (`type_of_activity` przy kontaktach
 * kontrahenta) po polsku — odpowiedzi Marathonu/Euvic 16.10.2026, pyt. 33e:
 * kody na `M` to osoby po stronie Marathona, kody na `C` — osoby u klienta
 * (kontrahenta). Kod zostaje w danych dosłownie; tu tylko etykieta na ekran.
 */

/** Kod → etykieta z oznaczeniem strony (klient / Marathon). */
export const CONTACT_CODE_LABELS: Readonly<Record<string, string>> = {
  CLOG: 'Logistyka (klient)',
  CPUR: 'Zakupy (klient)',
  CFIN: 'Finanse (klient)',
  CACC: 'Księgowość (klient)',
  CQUA: 'Jakość (klient)',
  CUIT: 'IT (klient)',
  MSAL: 'Sales (Marathon)',
  MCUS: 'Customer Service (Marathon)',
  MTRA: 'Trade (Marathon)',
  MFTL: 'FTL (Marathon)',
  MACC: 'Księgowość (Marathon)',
  MQUA: 'Jakość (Marathon)',
  MADM: 'Administracja (Marathon)',
};

const text = (v: unknown): string | null => (typeof v === 'string' && v.trim() !== '' ? v.trim() : null);

/**
 * Etykieta kodu kontaktu. Kod spoza listy: ze stroną z pierwszej litery
 * (reguła klienta: M* = Marathon, C* = klient), bez zgadywania działu;
 * inny — sam kod. Pusty — `null`.
 */
export function contactCodeLabel(code: unknown): string | null {
  const c = text(code);
  if (!c) return null;
  const known = CONTACT_CODE_LABELS[c.toUpperCase()];
  if (known) return known;
  const first = c[0].toUpperCase();
  if (first === 'M') return `${c} (Marathon)`;
  if (first === 'C') return `${c} (klient)`;
  return c;
}
